<script>
	// https://svelte.dev/docs#createEventDispatcher
	// tutorial/05-events/04-component-events
	import { createEventDispatcher } from "svelte";
	const dispatch = createEventDispatcher();

	import UTILS from "./classes/utilities.js";

	import OnOffSwitch from './UI/OnOffSwitch.svelte';

	export let supplement;
	export let isChecked = false;

	function increment() {
		dispatch("increment", supplement);
	}

	function decrement() {
		dispatch("decrement", supplement);
	}

	function checkBoxTick() {
		if (!isChecked) {
			increment();
		} else {
			decrement();
		}
	}
</script>

<div class="supplement">
	<OnOffSwitch
		id="{supplement.id}"
		value={isChecked}
		label="{supplement.name}"
	/>
	<p>
		<span>
			<input
				type="checkbox"
				bind:checked={isChecked}
				on:click={() => checkBoxTick()}
			/>
			{supplement.name}
		</span>
		<span class="price">{UTILS.formatMoney(supplement.price)}</span>
	</p>
</div>

<style>
	.supplement {
		border: 2px solid black;
		display: inline-block;
		margin: .2em .2em;
	}
	.supplement p {
		white-space: nowrap;
		padding: 0;
	}
</style>
